export const PathInvertedLogo = "logo-inverted.png";
export const ApiOnboardingPath = "onboardings";
